import MainLayout from "Layouts/Main";
import React, { useEffect, useRef, useState } from "react";
//assets
import assets from "../../../../Assets";
import { useLocation, useNavigate } from "react-router-dom";
import "./styles.scss";
import Button from "Components/Button";
import { useDispatch } from "react-redux";
import {
  sendReport,
  fetchIndividualInvestigation, fetchAssetDetails, fetchBearingDetails, fetchRecommendation, fetchSecondaryDetail,
  getFarReport
} from "../../../../Redux/Slices/failureAnalysisReqSlice";
import { Buffer } from "buffer";
import { notifySuccess } from "Services/Utils/toastNotification";
import MachineInformation from "Components/Request/FailureAnalysisRequest/MachineInformation";
import BearingUseInformation from "Components/Request/FailureAnalysisRequest/BearingUseInformation";
import LubricationDetails from "Components/Request/FailureAnalysisRequest/LubricationDetails";
import ImageModal from "Components/ImageModal";
import FailureDetails from "Components/Request/FailureAnalysisRequest/FailureDetails";
import Modal from "Components/Common/Modal";
import SecondaryDetails from "Components/SecondaryDetails";
import ReportDownload from "Components/ReportDownload";
import { uploadSingle } from "../../../../Redux/Slices/mainSlice";

const PreviewReport = () => {
  const location = useLocation();
  const remote_failure_details_id = location.state.remote_failure_details_id;
  const [previewDetails, setPreviewDetails] = useState({});
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pdfReport, setPdfReport] = useState(null)
  const [isShowDownload, setIsShowDownload] = useState(false)
  const [isLoading, setIsLoading] = useState(false);
  const downloadRef = useRef()
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const sendButton = {
    width: "230px",
  };

  useEffect(() => {
    dispatch(
      fetchIndividualInvestigation({
        data: {
          remote_failure_details_id: remote_failure_details_id,
        },
        callBack: (data) => {
          console.log(data?.data, 'kkk')
          setPreviewDetails(prevDetails => ({ ...prevDetails, investigation: data.data }))
        },
      })
    );
    dispatch(
      fetchAssetDetails({
        data: {
          remote_failure_details_id: remote_failure_details_id,
        },
        callBack: (data) => {
          console.log(data?.data, 'kkk')
          setPreviewDetails(prevDetails => ({ ...prevDetails, assets: data.data }))
        },
      })
    );
    dispatch(
      fetchBearingDetails({
        data: {
          remote_failure_details_id: remote_failure_details_id,
        },
        callBack: (data) => {
          console.log(data?.data, 'kkk')
          setPreviewDetails(prevDetails => ({ ...prevDetails, bearing: data.data }))
        },
      })
    );
    dispatch(
      fetchRecommendation({
        data: {
          remote_failure_details_id: remote_failure_details_id,
        },
        callBack: (data) => {
          const actualData = Array.isArray(data) ? data : data?.data;
          console.log(actualData, 'kkk');
          setPreviewDetails(prevDetails => ({ ...prevDetails, recommendation: actualData }));
        },
      })
    );
    dispatch(
      fetchSecondaryDetail({
        data: {
          remote_failure_details_id: remote_failure_details_id,
        },
        callBack: (data) => {
          console.log(data?.data, 'kkk')
          setPreviewDetails(prevDetails => ({ ...prevDetails, secondaryDetails: data.data }))
        },
      })
    );
    dispatch(
      getFarReport({
        data: {
          remote_failure_details_id: remote_failure_details_id,
        },
        callBack: (responseData) => {
          setPdfReport(responseData?.result)
        }
      })
    );
  }, []);

  const handleSend = () => {
    // console.log(previewDetails)
    setIsModalOpen(true)
  };

  const uploadGeneratedPdf = async (file, isLoadComplete) => {
    if (!file) return isLoadComplete();

    const formData = new FormData();
    formData.append("file", file);

    dispatch(
      uploadSingle({
        data: formData,
        callBack: async (value) => {
          try {
            await sendFarReportAndDownload(value);
          }
          catch (err) {
            console.error("Error in upload", err)
            isLoadComplete()
          }
        },
      })
    );
  };


  const sendFarReportAndDownload = async (value) => {
    const pdfUrl = value?.data?.url;
    if (!pdfUrl) return


    dispatch(
      sendReport({
        data: {
          id: remote_failure_details_id,
          report_url: pdfUrl,
        },
        callBack: () => {
          try {
            notifySuccess("Sent Successfully");
            navigate("/request/failureAnalysisRequest");
          }
          catch (err) {
            console.error("Error in sending report", err)
          }
          finally {
            isLoadComplete();
          }
        },
      })
    );
  };

  const isLoadComplete = async () => {
    setIsShowDownload(false);
    setIsLoading(false)
  }


  const handleClick = async () => {
    setIsModalOpen(false);
    setIsShowDownload(true);
    setIsLoading(true)

    setTimeout(async () => {
      try {
        if (downloadRef.current && pdfReport) {
          const file = await downloadRef.current.download();
          await uploadGeneratedPdf(file, isLoadComplete)
        }
      } catch (err) {
        console.error("Download failed", err);
      }
    }, 100);

  }

  return (
    <MainLayout pageName={"Failure Analysis Requests"}>
      <div
        className="goBackDivFailureRequests"
        onClick={() =>
          navigate("/request/failureAnalysisRequest/sendReport", {
            state: {
              remote_failure_details_id,
            },
          })
        }
      >
        <img src={assets.Icons.backArrow} alt="backIcon" />
        <p>Failure Analysis Report Preview</p>
      </div>

      <div className="previewWrap">
        <div className="previewButtonWrap">
          <div
            className="editButton"
            onClick={() =>
              navigate("/request/failureAnalysisRequest/sendReport", {
                state: {
                  remote_failure_details_id,
                },
              })
            }
          >
            Back to Edit
          </div>
          <Button title="Send" buttonStyle={sendButton} onClick={handleSend} />
        </div>
        <div className="reportWrapper">
          <h2>1. Initial Observations by Bearing Components</h2>
          <div className="investigationContainer">
            {Array.isArray(previewDetails?.investigation) && previewDetails.investigation.map((bearing, index) => (
              <div className="investigationBody" key={index}>
                {bearing?.bearing_number && (
                  <div className="bearingDetails">
                    {`Bearing Number - ${bearing.bearing_number}      ${bearing?.bearing_name || ""}`}
                  </div>
                )}
                <h3>{bearing?.bearing_component_list_name}</h3>
                <div className="imgAndObsContainer">
                  {bearing?.kgu_image_with_observations?.map((image, index) => (
                    <div className="imgAndObs" key={index}>
                      {image?.imgUrl === null ? "Image Not Provided" :
                        <ImageModal src={image?.imgUrl} alt="obsImage" />
                      }
                      <div dangerouslySetInnerHTML={{ __html: image?.imgObservation }}></div>
                    </div>
                  ))}
                </div>
                <div className="observationsContainer">
                  <h4>Observations</h4>
                  {bearing?.kgu_observations?.length > 0 && (
                    <ul className="observationList">
                      {bearing?.kgu_observations?.map((observation, index) => (
                        <li key={index} className="observationBody">
                          <div dangerouslySetInnerHTML={{ __html: observation?.observation_text }}></div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>

          <h2>2. Primary Mode of Failure</h2>
          <div className="investigationContainer">
            {Array.isArray(previewDetails?.assets) && previewDetails.assets.map((asset, index) => (
              <div className="investigationBody" key={index}>
                {asset?.bearing_number && (
                  <div className="bearingDetails">
                    {`Bearing Number - ${asset.bearing_number}      ${asset?.bearing_name || ""}`}
                  </div>
                )}
                <h3>{asset?.primary_mode_of_failure_type_name}</h3>
                <div className="imgAndObsContainer">
                  {asset?.kgu_image_with_failure_observations?.map(
                    (image, index) => (
                      <div className="imgAndObs" key={index}>
                        {image?.imgUrl === null ? "Image Not Provided" :
                          <ImageModal src={image?.imgUrl} alt="obsImage" />
                        }
                        <div dangerouslySetInnerHTML={{ __html: image?.img_cause_of_failure }}></div>
                      </div>
                    )
                  )}
                </div>
                <div className="observationsContainer">
                  <h4>Observations</h4>
                  {asset?.kgu_descriptions?.length > 0 && (
                    <ul className="observationList">
                      {asset?.kgu_descriptions?.map((observation, index) => (
                        <li key={index} className="observationBody">
                          <div dangerouslySetInnerHTML={{ __html: observation?.description_text }}></div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>

          <h2>3. Secondary Mode of Failure</h2>
          <div className="investigationContainer">
            {Array.isArray(previewDetails?.secondaryDetails) && previewDetails.secondaryDetails.map((asset, index) => (
              <div className="investigationBody" key={index}>
                {asset?.bearing_number && (
                  <div className="bearingDetails">
                    {`Bearing Number - ${asset.bearing_number}      ${asset?.bearing_name || ""}`}
                  </div>
                )}
                <h3>{asset?.additional_mode_of_failure_type_name}</h3>
                <div className="imgAndObsContainer">
                  {asset?.kgu_image_with_secondary_failure_observations?.map(
                    (image, index) => (
                      <div className="imgAndObs" key={index}>
                        {image?.img_url === null ? "Image Not Provided" :
                          <ImageModal src={image?.img_url} alt="obsImage" />
                        }
                        <div dangerouslySetInnerHTML={{ __html: image?.img_secondary_cause_of_failure }}></div>
                      </div>
                    )
                  )}
                </div>
                <div className="observationsContainer">
                  <h4>Observations</h4>
                  {asset?.kgu_secondary_descriptions?.length > 0 && (
                    <ul className="observationList">
                      {asset?.kgu_secondary_descriptions?.map((observation, index) => (
                        <li key={index} className="observationBody">
                          <div dangerouslySetInnerHTML={{ __html: observation?.secondary_description_text }}></div>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))}
          </div>
          <h2>4. Overall Bearing Analysis</h2>
          <div className="investigationContainer">
            {Array.isArray(previewDetails?.bearing) && previewDetails.bearing.map((bearing, index) => (
              <div className="investigationBody" key={index}>
                {(bearing?.bearing_number || bearing?.bearingNumber) && (
                  <div className="bearingDetails">
                    {`Bearing Number - ${bearing?.bearing_number || bearing?.bearingNumber}      ${bearing?.bearing_name || bearing?.bearingName || ""}`}
                  </div>
                )}
                <h3>Analysis</h3>
                {(() => {
                  const images = bearing?.images_and_description || bearing?.kgu_image_with_bearing_analysis_observations;
                  if (images && images.length > 0) {
                    return (
                      <div className="imgAndObsContainer">
                        {images.map((image, idx) => {
                          const src = image?.image !== undefined ? image?.image : image?.img_url;
                          const desc = image?.description !== undefined ? image?.description : image?.img_bearing_analysis_observation;
                          return (
                            <div className="imgAndObs" key={idx}>
                              {src === null || src === undefined ? "Image Not Provided" :
                                <ImageModal src={src} alt="obsImage" />
                              }
                              <div dangerouslySetInnerHTML={{ __html: desc || "" }}></div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  }
                  return null;
                })()}
                <div className="observationsContainer">
                  <h4>Observations</h4>
                  {bearing?.kgu_bearing_analysis_descriptions && bearing.kgu_bearing_analysis_descriptions.length > 0 ? (
                    <ul className="observationList">
                      {bearing.kgu_bearing_analysis_descriptions.map((observation, idx) => (
                        <li key={idx} className="observationBody">
                          <div dangerouslySetInnerHTML={{ __html: observation?.bearing_analysis_description_text }}></div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    bearing?.analysis && (
                      <ul className="observationList">
                        {Array.isArray(bearing.analysis) ? (
                          bearing.analysis.map((observation, idx) => (
                            <li key={idx} className="observationBody">
                              <div dangerouslySetInnerHTML={{ __html: observation?.text || "" }}></div>
                            </li>
                          ))
                        ) : (
                          <li className="observationBody">
                            <div dangerouslySetInnerHTML={{ __html: bearing.analysis }}></div>
                          </li>
                        )}
                      </ul>
                    )
                  )}
                </div>
              </div>
            ))}
          </div>
          <h2>5. Conclusions & Recommendations</h2>
          <div className="investigationContainer">
            {(() => {
              const recData = previewDetails?.recommendation;
              if (!recData) return null;
              const items = Array.isArray(recData) ? recData : 
                           (recData.conclusion || recData.recommendation || recData.conclusion_images) ? [recData] : [];

              return items.map((item, index) => (
                <div key={index} className="investigationBody">
                  <h3>Conclusion</h3>
                  <div className="observationsContainer">
                    <div className="observationBody" style={{ marginTop: '10px' }}>
                      <div dangerouslySetInnerHTML={{ __html: item?.conclusion || '' }}></div>
                    </div>
                  </div>

                  {item?.conclusion_images && item.conclusion_images.length > 0 && (
                    <div className="imgAndObsContainer" style={{ marginTop: '15px' }}>
                      {item.conclusion_images.map((image, i) => (
                        <div key={i} className="imgAndObs">
                          {image?.image === null ? "Image Not Provided" :
                            <ImageModal src={image?.image} alt="Conclusion Image" />
                          }
                          <div dangerouslySetInnerHTML={{ __html: image?.description || '' }}></div>
                        </div>
                      ))}
                    </div>
                  )}

                  <h3 style={{ marginTop: '20px' }}>Recommendation</h3>
                  <div className="observationsContainer">
                    <div className="observationBody" style={{ marginTop: '10px' }}>
                      <div dangerouslySetInnerHTML={{ __html: item?.recommendation || '' }}></div>
                    </div>
                  </div>

                  {item?.recommendation_images && item.recommendation_images.length > 0 && (
                    <div className="imgAndObsContainer" style={{ marginTop: '15px' }}>
                      {item.recommendation_images.map((image, i) => (
                        <div key={i} className="imgAndObs">
                          {image?.image === null ? "Image Not Provided" :
                            <ImageModal src={image?.image} alt="Recommendation Image" />
                          }
                          <div dangerouslySetInnerHTML={{ __html: image?.description || '' }}></div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ));
            })()}
          </div>
          <h2>6. Appendix</h2>
          <FailureDetails farId={remote_failure_details_id} />
          <MachineInformation farId={remote_failure_details_id} />
          <BearingUseInformation farId={remote_failure_details_id} />
          <LubricationDetails farId={remote_failure_details_id} />
        </div>
      </div>
      <Modal open={isModalOpen} closeModal={() => setIsModalOpen(false)}>
        <div style={{ textAlign: "center", fontFamily: "Roboto" }}>
          <h3>Request once submitted cannot be edited later. Are you sure to submit the request?</h3>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', paddingTop: '20px' }}>
            <Button
              buttonStyle={{
                width: "40%",
                height: "2vh",
              }}
              title="Yes"
              onClick={() => handleClick()}
            />
            <Button
              buttonStyle={{
                height: "2vh",
                backgroundColor: "#FFFFFF",
                border: "1px solid black",
                width: "40%",
              }}
              titleStlye={{ color: "#888888" }}
              title="No"
              onClick={() => setIsModalOpen(false)}
            />
          </div>
        </div>
      </Modal>
      {
        isShowDownload &&
        <ReportDownload resultData={pdfReport} ref={downloadRef} />
      }

      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            color: "#1f2155",
            fontFamily: "Poppins, sans-serif",
            zIndex: 10000,
            textAlign: "center",
          }}>
          <h2 style={{ marginBottom: "10px", fontSize: "4vh" }}>Loading</h2>
          <p style={{ fontSize: "14px" }}>
            Do not refresh or go back. Your Report is being downloaded. Please wait.
          </p>
        </div>
      )}
    </MainLayout>
  );
};

export default PreviewReport;
